import { render, staticRenderFns } from "./CustomerAuthList.vue?vue&type=template&id=c550d4d0&scoped=true"
import script from "./CustomerAuthList.vue?vue&type=script&lang=js"
export * from "./CustomerAuthList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c550d4d0",
  null
  
)

export default component.exports